import { CustomerFormValues } from "@/api/types";
import type { Customer } from "@/types/customer-type";
import { ApiResponse, PageContent } from '@/types/api-response';
import { apiClient } from '@/api/api-client';
import { Order, OrderResponse } from "@/types/order-type";
import { LowStockProduct, OrderSummary, SaleSummary } from "@/types/dashboard-type";
export async function getRevenueToday() {
    const response = await apiClient.get<number, {}>(`/dashboard/revenue`);
    return response;
}
export async function getPendingOrders() {
    const response = await apiClient.get<number, {}>(`/dashboard/pending-orders`);
    return response;
}
export async function getTopCustomers() {
    const response = await apiClient.get<Customer[], {}>(`/dashboard/top-customers`);
    return response;
}

export async function getTotalLowStock() {
    const response = await apiClient.get<number, {}>(`/dashboard/low-stock`);
    return response;
}
export async function getLast7DaysSale() {
    const response = await apiClient.get<OrderSummary[], {}>(`/dashboard/last-7-days-sale`);
    return response;
}
export async function getRecentOrders() {
    const response = await apiClient.get<Order[], {}>(`/dashboard/recent-orders`);
    return response;
}
export async function getTotalCustomer() {
    const response = await apiClient.get<number, {}>(`/dashboard/customers`);
    return response;
}
export async function getRevenue7Days() {
    const response = await apiClient.get<OrderSummary, {}>(`/dashboard/order-summary`);
    return response;

}

export async function refreshDashboard() {
    const response = await apiClient.get<void, {}>(`/dashboard/refresh`);
    return response;
}
export async function getLowStockProducts() {
    const response = await apiClient.get<LowStockProduct[], {}>(`/dashboard/low-stock-products`);
    return response;
}
export async function doReloadConversation() {
    const response = await apiClient.get<void, {}>(`/dashboard/reload-conversations`);
    return response;
}